import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import moment from 'moment';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';
import { FetchUsers } from '../Common/Services/UserService';

const LeaveTypeData = [
    { type: 1, Name: "Casual Leave" },
    { type: 2, Name: "Sick Leave" },
    { type: 3, Name: "Loss of Pay" }
];

const LeavesRecord = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [UsersData, setUsersData] = useState([]);
    const [LeavesData, setLeavesData] = useState([]);
    const [FilterLeavesData, setFilterLeavesData] = useState([]);
    const [SelectedLeaveType, setSelectedLeaveType] = useState(0);

    const Failure = (err) => {
        FailureAlert(err);
    };

    const FetchUsersData = () => {
        FetchUsers(null, UsersSuccess, Failure);
    };

    const GetSelectedUserLeaves = (value) => {
        if (parseInt(value) > 0) {
            Axiosfetch(baseURL + "GetLeaveInfoByUserID", "POST", { UserID: parseInt(value), LeaveYear: moment().year() }, UsersLeavesSuccess, Failure);
        }
        else {
            setLeavesData([]);
            setFilterLeavesData([]);
        }
    };

    const UsersLeavesSuccess = (data) => {
        if (data.length > 0) {
            setLeavesData(data);
            setFilterLeavesData(data);
        }
    };

    const UsersSuccess = (data) => {
        if (data.length > 0) {
            setUsersData(data);
        }
    };

    const GetSelectedLeaveTypeData = (leaveType) => {
        if (parseInt(leaveType) > 0) {
            setSelectedLeaveType(parseInt(leaveType));
            var data = LeavesData.filter(l => l.LeaveType === parseInt(leaveType));
            setFilterLeavesData(data);
        }
        else {
            setFilterLeavesData(LeavesData);
        }
    }

    useEffect(() => {
        FetchUsersData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Leaves Records</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-md-6 col-md-3 col-sm-3 align-right">
                        <div className="basic-select">
                            <select className="DropdownStyle" style={{ width: "70%" }} onChange={(e) => GetSelectedUserLeaves(e.target.value)}>
                                <option value="0">Select User</option>
                                {UsersData.length > 0 && UsersData.map(user => (
                                    <option value={user.ID}>{user.FirstName + " " + user.LastName}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 align-right">
                        <div className="basic-select">
                            <select className="DropdownStyle" style={{ width: "70%" }} onChange={(e) => GetSelectedLeaveTypeData(e.target.value)}>
                                <option value="0">Select Leave Type</option>
                                {
                                    LeaveTypeData.length && LeaveTypeData.map(leave => (
                                        <option key={leave.type} value={leave.type}>{leave.Name}</option>
                                    )
                                    )
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className="row" style={{ padding: "15px" }}>
                    <div className="col-md-12 tableQuotationRecordsStyle" style={{ scrollbarColor: "#005582 transparent" }}>
                        <table className="table table-striped">
                            <thead className="StickyHeader">
                                <tr>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Leave Type</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Leave Date</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Created Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    FilterLeavesData.length > 0 && FilterLeavesData.map(leaves => (
                                        <tr key={leaves.ID} className="textCenter">
                                            <td>{LeaveTypeData.filter(lt => lt.type === leaves.LeaveType).length > 0 ? LeaveTypeData.filter(lt => lt.type === leaves.LeaveType)[0].Name : ""}</td>
                                            <td>{moment(leaves.LeaveYear + "-" + leaves.LeaveMonth + "-" + leaves.LeaveDay).local().format("DD MMMM YYYY")}</td>
                                            <td>{moment(leaves.CreatedDate).local().format("DD MMMM YYYY hh:mm:ss A")}</td>
                                        </tr>
                                    ))
                                }
                                {
                                    FilterLeavesData.length === 0 && (<tr className="textCenter">
                                        <td colSpan="8">
                                            There are no {LeaveTypeData.filter(lt => lt.type === parseInt(SelectedLeaveType)).length > 0 ? LeaveTypeData.filter(lt => lt.type === parseInt(SelectedLeaveType))[0].Name : "Leaves"} available.
                                        </td>
                                    </tr>)
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeavesRecord;